module.exports = __webpack_public_path__ + "img/error.0ef923b6.svg";